/** Gap between export status polls (TanStack restarts it after each response). */
export const EXPORT_JOB_POLL_INTERVAL_MS = 3_000;
/** The gap once a job is slow or its polls keep failing. */
export const EXPORT_JOB_SLOW_POLL_INTERVAL_MS = 15_000;

/**
 * The start request's budget (past it the start settles as `timed_out`), and
 * how long a job polls before it is slow: its toast says it's taking longer,
 * and it polls at the slow cadence.
 */
export const EXPORT_JOB_BUDGET_MS = 5 * 60_000;

/**
 * How long a job is followed before it settles as `timed_out`: the backend's
 * PROFILE_EXPORT_IN_FLIGHT_WINDOW, past which it treats an export as stuck.
 */
export const EXPORT_JOB_MAX_POLL_MS = 2 * 60 * 60_000;

/** Poll errors in a row that switch to the slow cadence… */
export const EXPORT_JOB_ERROR_STREAK = 3;
/**
 * …and, when all are client errors (4xx) spanning at least this long since
 * the last good poll, settle the job as `lost`. Other errors never do.
 */
export const EXPORT_JOB_LOST_AFTER_MS = 20_000;

/**
 * Bounds concurrent fast polls (each one holds a BE connection during a worker
 * outage). A slow job, at the slow cadence, no longer counts.
 */
export const MAX_TRACKED_EXPORT_JOBS = 5;

export const EXPORT_RESULT_TOAST_MS = 8_000;
/**
 * A ready file My Exports doesn't list, waiting on its Download action: the
 * toast is the only way to it, so it stays until dismissed. The one export
 * toast that does.
 */
export const EXPORT_HELD_READY_TOAST_MS = Infinity;

export const MY_EXPORTS_HREF = "/settings/my-exports";
